export function addFeatureToMap(map, sourceID, geoJson, listeners = {}) {
    map.addSource(sourceID, {
        type: 'geojson',
        data: geoJson,
    });
    // Add a new layer to visualize the polygon.
    map.addLayer({
        id: 'fill' + sourceID,
        type: 'fill',
        source: sourceID, // reference the data source
        layout: {},
        paint: {
            'fill-color': '#0080ff', // blue color fill
            'fill-opacity': 0.5,
        },
    });
    // Add a black outline around the polygon.
    map.addLayer({
        id: 'outline' + sourceID,
        type: 'line',
        source: sourceID,
        layout: {},
        paint: {
            'line-color': '#000',
            'line-width': 2,
        },
    });
    map.on('mouseenter', 'fill' + sourceID, (e) => {
        map.setPaintProperty('fill' + sourceID, 'fill-opacity', 0.7);
        if (listeners.mouseenter) {
            listeners.mouseenter(e);
        }
    });
    map.on('mouseleave', 'fill' + sourceID, (e) => {
        map.getCanvas().style.cursor = '';
        map.setPaintProperty('fill' + sourceID, 'fill-opacity', 0.5);
        if (listeners.mouseleave) {
            listeners.mouseleave(e);
        }
    });
    map.on('click', 'fill' + sourceID, (e) => {
        if (listeners.click) {
            listeners.click(e);
        }
    });
    map.on('mousemove', 'fill' + sourceID, (e) => {
        if (listeners.mousemove) {
            listeners.mousemove(e);
        }
    });
    return sourceID;
}
//# sourceMappingURL=addFeatureToMap.js.map